module.exports = __webpack_public_path__ + "static/flight-3a-deecc4024ef259ad07ee6fdf4cad8b94.svg";